export const resources = {
  'vi-VN': {
    key: 'vi-VN',
    name: 'Tiếng Việt',
    icon: (
      <i className="icon-flag_vi_512x512">
        <span className="path1" />
        <span className="path2" />
      </i>
    ),
    apiValue: 'vi',
    shortDisplayName: 'VI',
  },
  'en-US': {
    key: 'en-US',
    name: 'English',
    icon: (
      <i className="icon-flag_en_512x512">
        <span className="path1" />
        <span className="path2" />
        <span className="path3" />
        <span className="path4" />
        <span className="path5" />
        <span className="path6" />
        <span className="path7" />
        <span className="path8" />
        <span className="path9" />
        <span className="path10" />
        <span className="path11" />
        <span className="path12" />
        <span className="path13" />
        <span className="path14" />
      </i>
    ),
    apiValue: 'en',
    shortDisplayName: 'EN',
  },
};
